import React, { useReducer, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, Button, Typography, responsiveFontSizes, Divider } from '@material-ui/core';
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import LabelSuccess from '../../componentes/labels/LabelSuccess';
import LabelError from '../../componentes/labels/LabelError';
import { DefaultDatagrid } from '../../componentes/datagrid/DefaultDatagrid';
import stockAdjustmentService from "./StockAdjustmentService";
import {
    FaHome,
    FaLink,
    FaUnlink
} from "react-icons/fa";
import InputField from "../../componentes/form-fields/InputField/InputField";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { Title } from "chart.js";
import CustomDatePicker from "../../componentes/form-fields/DatePicker/CustomDatePicker";
import DefaultRadioButton from '../../componentes/radio-buttons/DefaultRadioButton';

export default function StockAdjustment() {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");
    
    const initialState = {
        idProduct: 0,
        productCode:'',
        barCode:'',
        productName:'',
        dtBatch:null,
        quantity: '1',
        unitQuantityMove: '',
        itensForBox: '',
        quantityMovedForBox: '',
        idStorage: 0,
        idStreet: 0,
        idColumn: 0,
        idLevel: 0,
        action: '0',
        status: 1,
        userId: userId,
        warningMessage: '',
        
    };


    const [state, setState] = useState(initialState);
    const [alertType, setAlertType] = useState("warning");

    const {idProduct, productCode, barCode, productName, dtBatch, quantity, idStorage, idStreet, idColumn, idLevel } = state
    const {unitQuantityMove, quantityMovedForBox, itensForBox,status, action, watch } = state

    const [clearedState, setClearedState] = useState(false);
    const [message, setMessage] = useState("");
    const [warningMessage, setWarningMessage] = useState("");
    const [error, setError] = useState(warningMessage);
    const [success, setSuccess] = useState(false);
    const [unitQuantityMove1, setUnitQuantityMove] = useState("");

    const canSave = () => {

        let error = true;
        
        if (idProduct === 0) {
            setMessage(t("checkFields"));
            error = false;
        }

        if (quantity !== '')
        {
            if (quantity === '1') {
                if (!itensForBox.trim() || !quantityMovedForBox.trim()) {
                    setMessage(t("checkFields"));
                    error = false;
                }
            }

            if (quantity === '0') {
                if (!unitQuantityMove.toString().trim()) {
                    setMessage(t("checkFields"));
                    error = false;
                }
            }
        }
        else
        {
            setMessage(t("checkFields"));
            error = false;
        }

        if (action === '')
        {
            setMessage(t("checkFields"));
            error = false;
        }
        
        return error;

    };

      
    useEffect(() => {
        if (state.productCode) {
            handleCodeProduct();
        }
    }, [state.productCode]);

    useEffect(() => {
        if (state.barCode) {
            handleBarCode();
        }
    }, [state.barCode]);

    useEffect(() => {
        if (state.productName) {
            handleProductName();
        }
    }, [state.productName]);


    useEffect(() => {
    
        if (quantity === '0') {
            const QtdBox = parseInt(quantityMovedForBox, 10);
            const QtdForBox = parseInt(itensForBox, 10);
            if (!isNaN(QtdBox) && !isNaN(QtdForBox)) {
                setState(prevState => ({
                    ...prevState,
                    unitQuantityMove: QtdBox * QtdForBox,
                }));
            }
        }
    
}, [itensForBox, quantityMovedForBox, quantity]);


    const handleChange = (event) => {
        const { name, value } = event.target;
        setState({ ...state, [name]: value });
    };

    const handleCloseAlertState = () => {
        setState({ ...state, warningMessage: false });
    };

    const handleClear = () => {
        setClearedState(!clearedState);
        setState(initialState);
    };


    const handleCodeProduct = () => {
        let request = { ...state }
        stockAdjustmentService
            .getByCodeProduct(request)
            .then((response) => {
                
                if (response.data) {
                
                    setState(screen => ({
                        ...screen,
                        idProduct: response.data.idProduct,
                        barCode: response.data.barCode,
                        productName: response.data.productName,
                    }));
                }
            })
            .catch((e) => {
            });
    };

    const handleBarCode = () => {
        let request = { ...state }
        stockAdjustmentService
            .getByBarCode(request)
            .then((response) => {
                if (response.data) {
                
                    setState(screen => ({
                        ...screen,
                        idProduct: response.data.idProduct,
                        productCode: response.data.productCode,
                        productName: response.data.productName,
                    }));
                }
            })
            .catch((e) => {
            });
    };

     const handleProductName = () => {
            let request = { ...state }
    
            stockAdjustmentService
                .getByProductName(request)
                .then((response) => {
                    if (response.data) {
                        setState(screen => ({
                        ...screen,
                        idProduct: response.data.idProduct,
                        productCode: response.data.productCode,
                        barCode: response.data.barCode,
                    }));
                    }
                })
                .catch(() => {});
        };

    
    const radioList = [
        { value: '0', text: t("quantityBox") },
        { value: '1', text: t("quantityUnit") },
    ];

    const radioListAction = [
        { value: '0', text: t("stockInsert") },
        { value: '1', text: t("stockWithdrawal") },
    ];

    const handleSave = () => {
        if (!canSave())
        {
            setState({ ...state, warningMessage: true });
            setError(true);
            setSuccess(false);
            setWarningMessage(true);
        }
        
        let request = { ...state }

        
        setMessage("");
        setSuccess(false);
        setState({ ...state, warningMessage: false });
        stockAdjustmentService
            .saveStockAdjustment(request)
            .then((response) => {
                if (response.data.result === null)
                {
                    setState({ ...state, id: response.data.id })
                    setMessage(t("saveSuccess"));
                    setSuccess(true);
                    setWarningMessage(false);
                }
                else
                {
                    setMessage(response.data.result);
                    setState({ ...state, warningMessage: true });
                    setSuccess(false);
                    setWarningMessage(true);
                }
            })
            .catch((e) => {
                setMessage(t("saveError"));
                setSuccess(false);
                setWarningMessage(true);
                handlewarningMessage();
            });
        
    };

    const handlewarningMessage = () => {
        let result = true;
        if (state.role === 0) {
            setState({ ...state, warningMessage: true });
            result = false;
        }

        if ((state.id === 0) && (state.password === '' && state.confirmPassword === '') || (state.password !== state.confirmPassword)) {
            setState({ ...state, warningMessage: true });
            result = false;
        }

        if (result === true)
        {
            setState({ ...state, warningMessage: false });
        }
        
        return result;
    };

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="Ajuste de Estoque"
                fields={
                    <>
                        <GridItemContainer>
                            <CustomAlert
                                type={success ? "success" : warningMessage ? "warning" : "error"}
                                success={success}
                                message={message}
                                warning={warningMessage}
                                handleCloseAlert={handleCloseAlertState}
                                snackbar
                                autoClose
                            />
                            
                            <GridInputRow>
                                <Grid item xs={12}>
                                     <Typography  variant="subtitle1" style={{ fontWeight: 'bold' }}>{t("productInformation")}</Typography>
                                    <Divider />
                                </Grid>
                            </GridInputRow>

                            <GridInputRow>
                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="code" labelName="productCode" />
                                        }
                                        name="productCode"
                                        control={control}
                                        defaultValue=""
                                        label={t("productCode")}
                                        onChange={handleChange}
                                        value={productCode}
                                        length={30}
                                        error={warningMessage && productCode === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="code" labelName="barCode" />
                                        }
                                        name="barCode"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={barCode}
                                        length={30}
                                        error={warningMessage && barCode === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={4}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="product" labelName="productName" />
                                        } 
                                        name="productName"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={productName}
                                        length={100}
                                        error={warningMessage && productName === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={2} md={2}>
                                    <CustomDatePicker
                                        id="dtBatch"
                                        name="dtBatch"
                                        selectedDate={dtBatch}
                                        handleChange={handleChange}
                                        error={warningMessage && dtBatch === null}
                                    />
                                </Grid>
                            </GridInputRow>
                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={6}>
                                    <DefaultRadioButton
                                        name="quantity"
                                        control={control}
                                        defaultValue="0"
                                        list={radioList}
                                        value={quantity}
                                        onChange={handleChange}
                                        center={false}
                                        error={false}
                                    />
                                </Grid>
                                {quantity === '1' ?
                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="qtty" labelName="unitQuantityMove" />
                                        }
                                        name="unitQuantityMove"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={unitQuantityMove}
                                        length={10}
                                        inputProps={{ type: "number" }}
                                        error={warningMessage && unitQuantityMove === ""}
                                    />
                                </Grid>
                                :
                                <>
                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="qtty" labelName="itensForBox" />
                                        }
                                        name="itensForBox"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={itensForBox}
                                        length={10}
                                        inputProps={{ type: "number" }}
                                        error={warningMessage && itensForBox === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="qtty" labelName="quantityMovedForBox" />
                                        }
                                        name="quantityMovedForBox"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={quantityMovedForBox}
                                        length={10}
                                        inputProps={{ type: "number" }}
                                        error={warningMessage && quantityMovedForBox === ""}
                                    />
                                </Grid>
                                </>
                                }

                            </GridInputRow>

                            <GridInputRow>
                                <Grid item xs={12}>
                                     <Typography  variant="subtitle1" style={{ fontWeight: 'bold' }}>{t("informationLocationStock")}</Typography>
                                    <Divider />
                                </Grid>
                            </GridInputRow>

                            <GridInputRow>
                                <Grid item xs={12} sm={4} md={4}>
                                    <DefaultAutocomplete
                                        name={"idStorage"}
                                        onChange={handleChange}
                                        placeholder={t("storage")}
                                        label={t("storage")}
                                        useApi
                                        endpoint='GetStorageAutoComplete'
                                        value={idStorage}
                                        defaultSize
                                        error={warningMessage && idStorage === 0}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"idStreet"}
                                        onChange={handleChange}
                                        placeholder={t("street")}
                                        label={t("street")}
                                        useApi
                                        endpoint='GetStreetAutoComplete'
                                        value={idStreet}
                                        defaultSize
                                        error={warningMessage && idStreet === 0}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"idColumn"}
                                        onChange={handleChange}
                                        placeholder={t("column")}
                                        label={t("column")}
                                        useApi
                                        endpoint='GetColumnAutoComplete'
                                        value={idColumn}
                                        defaultSize
                                        error={warningMessage && idColumn === 0}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={2} md={2}>
                                    <DefaultAutocomplete
                                        name={"idLevel"}
                                        onChange={handleChange}
                                        placeholder={t("level")}
                                        label={t("level")}
                                        useApi
                                        endpoint='GetLevelAutoComplete'
                                        value={idLevel}
                                        defaultSize
                                        error={warningMessage && idLevel === 0}
                                    />
                                </Grid>
                            </GridInputRow>

                            <GridInputRow>
                                <Grid item xs={12}>
                                     <Typography  variant="subtitle1" style={{ fontWeight: 'bold' }}>{t("action")}</Typography>
                                    <Divider />
                                </Grid>
                            </GridInputRow>

                            <GridInputRow>
                                <Grid item xs={12} sm={4} md={4}>
                                    <DefaultRadioButton
                                        name="action"
                                        control={control}
                                        defaultValue="0"
                                        list={radioListAction}
                                        value={action}
                                        onChange={handleChange}
                                        center={false}
                                        error={false}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"status"}
                                        onChange={handleChange}
                                        value={status}
                                        label={t("status")}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("canceled"), status: 1 },
                                            { id: 1, name: t("active"), status: 1 },
                                            { id: 2, name: t("all"), status: 1 },
                                        ]}
                                    />
                                </Grid>
                            </GridInputRow>
                            
                            {<SearchClearSaveRow
                                onClickClear={handleClear}
                                onClickSave={handleSave}
                            />}

                        </GridItemContainer>
                    </>
                }
            />
        </>
    );
};
